import React from 'react';
import { useNavigate } from 'react-router-dom';
import { products } from '../data/products';
import { productsPage as P } from '../data/pages';
import PageHero from '../components/PageHero';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

export default function ProductsPage() {
  const navigate = useNavigate();
  const toGrid = () => document.getElementById('product-grid').scrollIntoView({ behavior: 'smooth' });
  return (
    <>
      <PageHero art="mosaic" title={P.hero.title} text={P.hero.text} primary={{ label: P.hero.button, onClick: toGrid, glass: true }} />

      <section id="product-grid" className="section">
        <div className="container">
          <SectionHeading row title="Our Products" text={P.hero.text} />
          <div className="pgrid">
            {products.map((p, i) => (
              <Reveal key={p.name} delay={(i % 2) * 80} className={i === products.length - 1 && products.length % 2 ? 'pgrid__wide' : ''}>
                <article className="pcard pcard--icon" tabIndex={0}>
                  <span className="pcard__icon"><Icon name={p.icon} size={96} /></span>
                  <div className="pcard__over">
                    <h3>{p.name}</h3>
                    <span>{p.short}</span>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal className="feat">
            <div className="feat__text">
              <span className="feat__label">{P.featured.label}</span>
              <h2>{P.featured.title}</h2>
              <p>{P.featured.text}</p>
              <button className="btn btn--primary btn--sm" onClick={() => navigate('/contact')}>{P.featured.button} <Icon name="arrow" size={16} /></button>
            </div>
            <div className="feat__phone" aria-hidden="true">
              <div><Icon name="check" size={28} /><b>Verified</b><i /><i /><i /></div>
            </div>
            <ul className="feat__badges">
              {P.featured.badges.map((b) => (<li key={b}>{b}<Icon name="check" size={18} /></li>))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal><h2 className="bigh">Why Choose<br />Our Products</h2></Reveal>
          <Reveal delay={80} className="prose prose--wide"><p>{P.whyText}</p></Reveal>
          <div className="whyrow">
            {P.why.map((w, i) => (
              <Reveal key={w.title} delay={i * 70} className="whyrow__item">
                <Icon name={w.icon} size={40} />
                <h3>{w.title}</h3>
                <p>{w.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal className="ctabanner">
            <div>
              <h2>Ready to Transform Your Business?</h2>
              <p>Discover the right solution for your business and take the first step toward digital transformation.</p>
            </div>
            <div className="ctabanner__btns">
              <button className="btn btn--primary btn--sm" onClick={() => navigate('/contact')}>Request Demo <Icon name="arrow" size={16} /></button>
              <button className="btn btn--outline btn--sm" onClick={() => navigate('/contact')}>Contact Us <Icon name="arrow" size={16} /></button>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
